import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16z" }), /* @__PURE__ */ _jsx("path", { d: "M16 11h-3V8a1 1 0 00-2 0v4a1 1 0 001 1h4a1 1 0 000-2z" })]
		})
	})
});
export { SvgClock as ReactComponent };
